export * from './add-to-playlist/add-to-playlist.component';
export * from './add-to-playlist/add-to-playlist-dialog/add-to-playlist-dialog.component';
export * from './song-detail/song-detail.component';
export * from './song-item/song-item.component';
export * from './songs.component';
export * from './song-detail-page/song-detail-page.component';
export * from './add-to-queue/add-to-queue.component';
export * from './delete-from-playlist/delete-from-playlist.component';
export * from './songs-search-on-credits/songs-search-on-credits.component';


// WEBPACK FOOTER //
// ./src/app/songs/index.ts